import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FiWrapperTableCellBase } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-cell-base';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';

@Component({
    selector: 'fi-wrapper-table-span-array-cell',
    template: `
        @for (item of value; track $index; let index = $index; let last = $last) {
          <span
            [ngClass]="getItemClass(item)"
            [textContent]="last ? item.Name : item.Name + ', '"
            [attr.title]="item.Name"
            (click)="onItemClick($event, item.Id)"
            >
          </span>
        }
        `,
    styleUrls: ['./fi-wrapper-table-span-array-cell.component.scss'],
    standalone: false,
})
export class FiWrapperTableSpanArrayCellComponent extends FiWrapperTableCellBase<INameIdObj[]> {
    @Input() textMode: boolean;
    @Input() getItemClassFn?: (itemId: number) => string = () => '';
    @Output() itemClick = new EventEmitter<number>();

    onItemClick($event: MouseEvent, itemId: number) {
        $event.stopPropagation();
        if (!this.textMode) {
            this.itemClick.emit(itemId);
        }
    }

    getItemClass(item: INameIdObj): { [key: string]: boolean } {
        const itemClass = this.getItemClassFn ? this.getItemClassFn(item.Id) : '';
        return {
            BrandedColorHover: !this.textMode,
            'cursor-pointer': !this.textMode,
            [itemClass]: !!itemClass,
        };
    }
}
